import { StoreEntity } from "~/interfaces/entities/Store"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: stores, selectors: storesSelectors } = createEntitySlice<
  StoreEntity
>("stores")
